export default "__VITE_ASSET__vdKzuUWZ__"